// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Paginate_pagination__1f7sm","paginationLink":"Paginate_paginationLink__3co8F","paginationLinkActive":"Paginate_paginationLinkActive__3yAPN"};